import React from 'react'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Banner = ({
  title = '',
  subtitle = '',
  state = 'success',
  onClose,
  children, // render button, CTA, link or similar
  ...props
}) => {

  const classes = [
    'w-full',
    'border',
    'rounded',
    'py-3',
    'px-4',
    'shadow-md',
    'text-sm',
    'flex',
    'justify-between',
    'text-white'
  ]

  const iconClasses = ['mr-2']

  const titleClasses = ['inline', 'font-bold', 'mr-4', 'whitespace-pre-line']

  const subtitleClasses = ['inline']

  const closeButtonClasses = ['px-2']

  classes.push({
    success: 'bg-positive',
    error: 'bg-negative',
    warning: 'bg-warning',
    info: 'bg-primary'
  }[state] || 'bg-primary')

  const icon = {
    success: 'fa-check',
    error: 'fa-exclamation-circle',
    warning: 'fa-warning',
    info: 'fa-circle-info'
  }[state] || 'fa-circle-info'

  return (
    <div {...props} className={classNames(classes)}>
      <div className="flex items-center">
        <FontAwesomeIcon
          className={classNames(iconClasses)}
          icon={`fa-solid ${icon}`}
        />
        { !!title.length &&
          <div className={classNames(titleClasses)}>{ title }</div>
        }
        { !!subtitle.length &&
          <div className={classNames(subtitleClasses)}>{ subtitle }</div>
        }
      </div>
      <div className="flex space-x-2">
        { children &&
          <div>
            { children }
          </div>
        }

        { onClose &&
          <button onClick={onClose}>
            <FontAwesomeIcon
              className={classNames(closeButtonClasses)}
              icon="fa-solid fa-times"
            />
          </button>
        }
      </div>
    </div>
  )
}

export default Banner
